<template>
  <app-dialog
    v-model="openModel"
    content-class="dialogGuaranteeDailyTrouble guaranteeModal"
    @onClose="$emit('onClose')"
  >
    <template v-slot:title>
      <h1 class="dialogGuaranteeDailyTrouble-title">日常のトラブルを補償</h1>
    </template>
    <v-card class="dialogGuaranteeDailyTrouble-content">
      <v-card-text class="dialogGuaranteeDailyTrouble-content">
        <div class="his-tbl_wrapper">
          <table>
            <tbody>
              <tr>
                <th colspan="5">補償内容</th>
              </tr>
              <tr>
                <th></th>
                <th>Ｘ型</th>
                <th>Ｚ型</th>
              </tr>
              <tr>
                <td>月額保険料</td>
                <td data-label="Ｘ型"><span>９０</span>円<br /></td>
                <td data-label="Ｚ型"><span>８０</span>円<br /></td>
              </tr>
              <tr>
                <td>支払限度額</td>
                <td data-label="Ｘ型">
                  <span>日本国内無制限</span><br /><span
                    >(日本国外１億円限度)</span
                  >
                </td>
                <td data-label="Ｚ型"><span>１億</span>円</td>
              </tr>
            </tbody>
          </table>
          <div>
            <div class="pointTitle">特長</div>
            <div class="pointBox">
              <dl>
                <dt>1</dt>
                <dd>ご本人の加入で<br /><strong>ご家族全員を補償</strong></dd>
              </dl>
              <dl>
                <dt>2</dt>
                <dd>
                  <strong>日本国内無制限の補償</strong
                  ><br />(日本国外は1億円限度)が選択可能
                </dd>
              </dl>
              <dl>
                <dt>3</dt>
                <dd>
                  <strong>日本国内示談<br />交渉サービス</strong>つき
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </app-dialog>
</template>

<script>
export default {
  name: 'DialogGuaranteeReduceIncome',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    openModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss">
.dialogGuaranteeDailyTrouble {
  width: 690px;
  max-width: 700px;
  &-content {
    &.v-card__text {
      padding: 0 30px 20px;
    }
  }
  &-title {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: #333;
    margin-top: 15px;
    margin-bottom: 5px;
    width: 100%;
  }
}
</style>
